module.exports = __webpack_public_path__ + "media/newstyle/images/icon-separated-cover-3afc0101b4cd16239de55f5381aa9972.svg";